/* eslint-disable jsx-a11y/anchor-is-valid */

import cx from "classnames";
import React from "react";
import { useHistory } from "react-router-dom";
import { adobeClickTracking } from "../../../../../helpers/tracking";
import { routePath } from "../../../../../helpers/urlPathMapping";

import sharedStyles from "../../../SharedStyles.module.scss";
import styles from "../Home.module.scss";

const HomeButtom = ({ type }) => {
  const history = useHistory();
  const gamesType = type === "single" ? "Single Game" : "Group";
  const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets`;

  return (
    <div>
      <h1 className={cx(sharedStyles.header, sharedStyles.header_line)}>
        <span></span>
        <span>Choose Your Own Adventure</span>
        <span></span>
      </h1>
      <div className={styles.cards}>
        <div
          className={styles.card}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: routePath(type).BY_OPPONENT.prop14,
            });
            history.push(routePath(type).BY_OPPONENT.path);
          }}
        >
          <img
            src={require("../../../../../assets/images/img-opponent.png")}
            alt=""
          />
          <div className={styles.title}>
            <h1>By Opponent</h1>
            <img
              className={styles.arrow}
              src={require("../../../../../assets/images/icons/arrow-icon.svg")}
              alt=""
            />
          </div>
          <div className={styles.info}>
            <img
              className={styles.icon}
              src={require("../../../../../assets/images/icons/icon-opponent.svg")}
              alt=""
            />
          </div>
        </div>
        {/* TODO: uncomment this on launch giveaway */}
        <div
          className={styles.card}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: routePath(type).BY_GIVEAWAY.prop14,
            });
            history.push(routePath(type).BY_GIVEAWAY.path);
          }}
        >
          <img
            src={require("../../../../../assets/images/img-giveaway.png")}
            alt=""
          />
          <div className={styles.title}>
            <h1>
              By Giveaway/
              <br />
              Promotion
            </h1>
            <img
              className={styles.arrow}
              src={require("../../../../../assets/images/icons/arrow-icon.svg")}
              alt=""
            />
          </div>
          <div className={styles.info}>
            <img
              className={styles.icon}
              src={require("../../../../../assets/images/icons/icon-giveaway.svg")}
              alt=""
            />
          </div>
        </div>
        <div
          className={styles.card}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: routePath(type).BY_DAY_OF_WEEK.prop14,
            });
            history.push(routePath(type).BY_DAY_OF_WEEK.path);
          }}
        >
          <img
            src={require("../../../../../assets/images/img-day-of-week.jpg")}
            alt=""
          />
          <div className={styles.title}>
            <h1>By Day of Week</h1>
            <img
              className={styles.arrow}
              src={require("../../../../../assets/images/icons/arrow-icon.svg")}
              alt=""
            />
          </div>
          <div className={styles.info}>
            <img
              className={styles.icon}
              src={require("../../../../../assets/images/icons/icon-day-of-week.svg")}
              alt=""
            />
          </div>
        </div>
        <div
          className={styles.card}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: routePath(type).BY_TIME_OF_DAY.prop14,
            });
            history.push(routePath(type).BY_TIME_OF_DAY.path);
          }}
        >
          <img
            src={require("../../../../../assets/images/img-time-of-day.png")}
            alt=""
          />
          <div className={styles.title}>
            <h1>By Time of Day </h1>
            <img
              className={styles.arrow}
              src={require("../../../../../assets/images/icons/arrow-icon.svg")}
              alt=""
            />
          </div>
          <div className={styles.info}>
            <img
              className={styles.icon}
              src={require("../../../../../assets/images/icons/icon-time-of-day.svg")}
              alt=""
            />
          </div>
        </div>
        <div
          className={styles.card}
          onClick={() => {
            adobeClickTracking({
              prop13,
              prop14: routePath(type).BY_PRICE.prop14,
            });
            history.push(routePath(type).BY_PRICE.path);
          }}
        >
          <img
            src={require("../../../../../assets/images/img-price.png")}
            alt=""
          />
          <div className={styles.title}>
            <h1>By Price</h1>
            <img
              className={styles.arrow}
              src={require("../../../../../assets/images/icons/arrow-icon.svg")}
              alt=""
            />
          </div>
          <div className={styles.info}>
            <img
              className={styles.icon}
              src={require("../../../../../assets/images/icons/icon-price.svg")}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeButtom;
